var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'chip')?_c('v-chip',{attrs:{"outlined":"","small":"","color":_vm.config.color}},[_vm._v(_vm._s(_vm.config.title))]):_c('span',{class:_vm.config.color + '--text'},[_vm._v(_vm._s(_vm.config.title))])}
var staticRenderFns = []

export { render, staticRenderFns }